import {getOrganisationPublicationsList,removePublicationFromOrganisation} from '@/libs/api/api'
import {errorHandler, message, logout, loader, getImageUrl, onError} from '@/libs/helper';
import constants from '@/libs/constant/constants'
import pageRoutes from '@/libs/constant/pageRoutes'
export default {
    data() { 
        return {
            showAddPublication: false,
            publicationsList: [],
            getImageUrl,
            onError
        }
    },
    mounted() {
        this.fetchPublications()
    },
    methods: {
        async fetchPublications() {
            loader(this, true)
            try {
                const results = await getOrganisationPublicationsList(this.organisationDetails._id || this.$route.params.id)
                this.publicationsList = results.items
                loader(this, false)
            } catch (error) {
                loader(this, false)
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                console.log(error)
            }
        },
        async remove(publication_id) {
            try {
                loader(this, true)
                const result = await removePublicationFromOrganisation(this.organisationDetails._id, publication_id)
                if (result) {
                    this.fetchPublications()
                }
            } catch (error) {
                loader(this, false)
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                console.log(error)
            }
        },
        handleAddPublication () {
            this.$router.push({name: 'org-add-publication'})
        },
        routeToOverViewPage (type, meta) {
            let routeName = ``
            switch (type) {
                case constants.AUTHOR.key:
                    routeName = pageRoutes.authorOverview
                break
                case constants.PUBLICATION.key:
                    routeName = pageRoutes.publicationOverview
                break
                case constants.PUBLISHER.key:
                    routeName = pageRoutes.publisherOverview
                break
            }
            this.$router.push({name: routeName, params: {id: meta._id}}).catch(() => {})
        }
    },
    props: {
        organisationDetails: {
            type: Object,
            default: () => {}
        }
    },
}